import http from '../base/http';
import Config from '@/config';

export const testSignature = async () => {
  const bffEndpoint = `${Config.BFF_SERVICE.URL}`;
  const result = await http.post<BFFResponse<any>>(
    `${bffEndpoint}/wmp-bff/demo/signature-test`,
    {
      testData: 'signature test request',
      timestamp: Date.now(),
    },
  );
  return result.data;
};
